/** Saudi mobile stored as 10 digits (e.g. 5012345678 or 0501234567). Returns E.164 for tel: links. */
export function saudiTelHref(phone) {
  const d = String(phone || '').replace(/\D/g, '');
  if (d.length !== 10) return '';
  const national = d.startsWith('0') ? d.slice(1) : d;
  return `tel:+966${national}`;
}
